import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

/*Services*/
import { CrudService } from '@services/laravel/crud.service';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { MatButton } from '@angular/material/button';

@Component({
    standalone: true,
    selector: 'app-ntm-loading-modal',
    templateUrl: './loading-modal.component.html',
    styleUrls: ['./loading-modal.component.css'],
    imports: [ModalHeaderComponent, CdkScrollable, MatDialogContent, MatProgressSpinner, MatButton]
})

export class LoadingModalComponent implements OnInit {
  @Output()
  change: EventEmitter<string> = new EventEmitter<string>();

  title: any;
  mensagem: any;
  status: any;
  color: any;
  showBtn: boolean = true;
  setTimer: boolean = false;

  alert_type_1: any = false;
  alert_type_2: any = false;

  dataToDelete: any;
  dialogMessage: string;
  constructor(
    public dialogRef: MatDialogRef<LoadingModalComponent>,
    private crud: CrudService,
    private router: Router,
    private matsnackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  ngOnInit() {
    
  }

  onDialogClose = () => {
    this.dialogRef.close(false);
  }
}
